'use client'

import cx from 'classnames'
import { ReactNode } from 'react'

import InViewDebutLogic from '@/components/Page/Teaser/Introduction/Debut/InViewDebutLogic'

export default function DebutView({
  leftBgComponent,
  rightBgComponent,
  leftComponent,
  rightComponent,
  extraRightComponent,
  speed,
}: {
  leftBgComponent: ReactNode
  rightBgComponent: ReactNode
  leftComponent: ReactNode
  rightComponent: ReactNode
  extraRightComponent: ReactNode | null
  speed: number
}) {
  const rootMargin = '0px 0px -3% 0px'

  const id = 'popupSection'
  const trigger = 'popupWrapper'

  return (
    <section id={trigger} className={cx(...['sm:flex'])}>
      <div id={id} className={cx('w-full', ...['sm:w-1/2', 'sm:overflow-hidden', 'sm:h-safari-screen'])}>
        <InViewDebutLogic rootMargin={rootMargin} fadeSpeed={speed} />
        <section className={cx('relative')}>
          {leftBgComponent}
          {leftComponent}
        </section>
      </div>
      <div className={cx('w-full', ...['sm:w-1/2'])}>
        <div className={cx(...['sm:overflow-hidden', 'sm:h-safari-screen'])}>
          <section className={cx('relative')}>
            {rightBgComponent}
            {rightComponent}
          </section>
        </div>
        {extraRightComponent}
      </div>
    </section>
  )
}
